import { AjaxFetch, Fingerprints } from '@grammarly/http-clients'
import { Analytics } from '@grammarly/http-clients-analytics'
import { Auth } from '@grammarly/http-clients-auth'
import { CAPIHttpClient } from '@grammarly/http-clients-capi'
import { Institution } from '@grammarly/http-clients-institution'
import { SettingsRegistry } from '@grammarly/http-clients-settings-registry'
import { DoxClient } from '@grammarly/http-clients-dox'
import { Cheetah } from '@grammarly/http-clients-cheetah'
import { SubscriptionClient } from '@grammarly/http-clients-subscription'
import { getConfig } from '../../../config'
import { gnarClient } from '../../tracking/gnar'
import { clientName, clientNameFunnel, clientVersion, getCsrfToken } from './fingerprints'

const { api } = getConfig()

export class ApiService {
  constructor(private readonly fetch: typeof window.fetch) {}

  private ajaxFactory = AjaxFetch.create(this.fetch)

  private serviceFingerprints: Fingerprints = {
    clientName,
    clientVersion,
    containerId: gnarClient.getContainerId(),
    csrfToken: () => Promise.resolve(getCsrfToken()),
  }

  private serviceFingerprintsFunnel: Fingerprints = {
    clientName: clientNameFunnel,
    clientVersion,
    containerId: gnarClient.getContainerId(),
    csrfToken: () => Promise.resolve(getCsrfToken()),
  }

  public readonly analytics = new Analytics(api.analytics, this.ajaxFactory, this.serviceFingerprints)
  public readonly auth = new Auth(api.auth, this.ajaxFactory, this.serviceFingerprints)
  public readonly capi = new CAPIHttpClient(api.capi, this.ajaxFactory, this.serviceFingerprints)
  public readonly institution = new Institution(api.institution, this.ajaxFactory, this.serviceFingerprints)
  public readonly subscription = new SubscriptionClient(api.subscription, this.ajaxFactory, this.serviceFingerprints)
  public readonly dox = new DoxClient(api.dox, this.ajaxFactory, this.serviceFingerprints)
  public readonly cheetah = new Cheetah(api.cheetah, this.ajaxFactory, this.serviceFingerprintsFunnel)

  public readonly settingsRegistry = new SettingsRegistry(
    api.settingsRegistry,
    this.ajaxFactory,
    this.serviceFingerprints
  )
}
